import React from "react";
import { BtnThemMoi } from "./ThemMoi/BtnThemMoi";
import { ContentTable } from "./ContentTable";

export const TablePhiKhac = ({ isLoading, listDanhSach, CustomCheckbox, onEdit, onDelete, onUse }) => {
    return (
        <div className="form form-horizontal">
            <div className="form-body">
                <div className="Left808x200 Table-main-new css-table-ds mt-2">
                    <div className="row col-sm-12 col-md-12 themoi-taisanthly mb-1">
                        <div className="col-sm-12 col-md-10">
                            <BtnThemMoi onEdit={onEdit}/>
                        </div>
                    </div>
                    <div className="table-mobile table-mobile-hover">
                        <div className="custom-table-wrapper" style={{ overflowX: "auto" }}>
                            <div className="table-headers" style={{alignItems: 'stretch'}}>
                                <div className="custom-table-header text-left flex-basis-35 flex-basis-35-sm">
                                    <p>Tên phí khác</p>
                                </div>
                                <div className="custom-table-header text-left flex-basis-30 flex-basis-30-sm">
                                    <p>Kiểu nhập liệu</p>
                                </div>
                                <div className="custom-table-header text-center flex-basis-15 flex-basis-15-sm">
                                    <p>Sử dụng</p>
                                </div>
                                <div className="custom-table-header text-center flex-basis-20 flex-basis-20-sm">
                                    <p>Chức năng</p>
                                </div>
                            </div>
                            <div className="custom-table-body">
                                {isLoading ? (
                                    <div className="loading-page1"><div className="loader loader-default is-active"></div></div>
                                ) : (
                                    <ContentTable
                                        listDanhSach={listDanhSach.List}
                                        CustomCheckbox={CustomCheckbox}
                                        onEdit={onEdit}
                                        onDelete={onDelete}
                                        onUse={onUse}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};